module.exports = __webpack_public_path__ + "img/appointment.cb548bf.jpg";